import { effect, Signal, signal } from '@preact/signals-react';

export function debounced<T>(
  derive: Signal<T>,
  delay = 300,
): { value: Signal<T>; dispose: () => void } {
  const out = signal(derive.peek());
  let t: NodeJS.Timeout;

  const dispose = effect(() => {
    const next = derive.value;
    clearTimeout(t);
    t = setTimeout(() => {
      out.value = next;
    }, delay);

    return () => clearTimeout(t);
  });

  return { value: out, dispose };
}
